import React from 'react';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-types-papi';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import { PANEL_HEIGHT } from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop/ShopThumb';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import ShopThumb, {
  ShopThumbType,
} from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Shop';
import EmptyState from '../../_partials/EmptyState';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

export interface Props {
  streamId: string;
  moduleId: number;
  premiumContentDeviations: PapiDeviation[];
  total: number;
  isOwner: boolean;
  username: string;
  isMobile?: boolean;
}

export class PremiumContentSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      isMobile,
      streamId,
      t,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      premiumContentDeviations,
      total,
      username,
    } = this.props;

    const isEmpty = !premiumContentDeviations.length;

    return (
      <WidgetBox
        header={t!('common.premiumContent')}
        count={total}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={<EmptyState view="wide" shopItemType="premiumContent" />}
        seeAllUrl={Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT
        )}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={premiumContentDeviations}
          parent={{ title: t('common.someonesShop', { username }) }}
        >
          {isMobile ? (
            <SwipeSlider>
              {premiumContentDeviations.map(deviation => (
                <ShopThumb
                  key={deviation.deviationId}
                  deviation={deviation}
                  type={ShopThumbType.PCP}
                  showAuthor={false}
                />
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize =>
                premiumContentDeviations.map(deviation => (
                  <ShopThumb
                    key={deviation.deviationId}
                    deviation={deviation}
                    width={elementSize.width}
                    height={elementSize.height + PANEL_HEIGHT}
                    type={ShopThumbType.PCP}
                    showAuthor={false}
                  />
                ))
              }
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(withTranslation()(PremiumContentSlider));
